import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mushroom-1","clipPath":"url(#clip0_543_6593)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21.5486 15.1783C19.7912 16.9357 16.5781 14.4503 13.0634 10.9356C9.54865 7.42088 7.06331 4.20773 8.82067 2.45037C10.578 0.693014 15.0077 0.504563 19.2505 4.74847C23.4932 8.99238 23.306 13.4209 21.5486 15.1783Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3.51729 20.4817C7.05288 24.0229 9.18226 23.2974 10.9419 21.5423C13.0369 19.4528 14.4362 15.2936 16.0107 13.6502C15.0721 12.8835 14.0804 11.9526 13.0634 10.9356C12.0463 9.9186 11.1155 8.92683 10.3487 7.98828C8.70547 9.56286 4.54886 10.9648 2.45663 13.0571C0.699269 14.8144 -0.0183103 16.9404 3.51729 20.4817Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3.51729 20.4817C7.05288 24.0229 9.18226 23.2974 10.9419 21.5423C13.0369 19.4528 14.4362 15.2936 16.0107 13.6502C15.0721 12.8835 14.0804 11.9526 13.0634 10.9356C12.0463 9.9186 11.1155 8.92683 10.3487 7.98828C8.70547 9.56286 4.54886 10.9648 2.45663 13.0571C0.699269 14.8144 -0.0183101 16.9404 3.51729 20.4817Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21.5486 15.1783C19.7912 16.9357 16.5781 14.4503 13.0634 10.9356C9.54865 7.42088 7.06331 4.20773 8.82067 2.45037C10.578 0.693014 15.0077 0.504563 19.2505 4.74847C23.4932 8.99238 23.306 13.4209 21.5486 15.1783Z","strokeWidth":"props.strokeWidth"}}]}]};

const Mushroom1 = Vue.extend<IconProps>({
  name: 'Mushroom1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mushroom-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Mushroom1;
